import { render, staticRenderFns } from "./FollowerCard.vue?vue&type=template&id=187bc425&scoped=true&"
import script from "./FollowerCard.vue?vue&type=script&lang=js&"
export * from "./FollowerCard.vue?vue&type=script&lang=js&"
import style0 from "./FollowerCard.vue?vue&type=style&index=0&id=187bc425&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187bc425",
  null
  
)

export default component.exports